import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

import { tokenManager } from './tokenManager'

const cache = new InMemoryCache()

const httpLink = createHttpLink({
  headers: {},
  uri: `${window.extensionApiOrigin}/api/graphql-admin/`,
})

const authLink = setContext(async (_, { headers }) => {
  const token = await tokenManager.getToken()

  return {
    headers: {
      ...headers,
      ...(token && { authorization: `Bearer ${token}` }),
    },
  }
})

const errorLink = onError(({ networkError, operation, forward }) => {
  let statusCode: number | undefined

  if (networkError && 'statusCode' in networkError) {
    statusCode = (networkError as any).statusCode
  } else if (
    networkError &&
    'response' in networkError &&
    networkError.response
  ) {
    statusCode = (networkError.response as any).status
  }

  if (statusCode === 401 || statusCode === 403) {
    tokenManager.clearCache()
  }
  return forward(operation)
})

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages()
  loadErrorMessages()
}

export const client = new ApolloClient({
  cache,
  // In our case, we always want updated data, so we default to no-cache.
  // This means "fetch from server, and don't even bother to update the cache".
  defaultOptions: { query: { fetchPolicy: 'no-cache' } },
  link: errorLink.concat(authLink.concat(httpLink)),
})
